"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Storage(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 10a3 3 0 110 6H3a3 3 0 110-6h10zm0 1H3a2 2 0 00-.149 3.995L3 15h10a2 2 0 00.149-3.995L13 11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5a3 3 0 110 6H3a3 3 0 110-6h10zm0 1H3a2 2 0 00-.149 3.995L3 10h10a2 2 0 00.149-3.995L13 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 0a3 3 0 110 6H3a3 3 0 110-6h10zm0 1H3a2 2 0 00-.149 3.995L3 5h10a2 2 0 00.149-3.995L13 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3a.5.5 0 110 1 .5.5 0 010-1zm3 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm-3 5a.5.5 0 110 1 .5.5 0 010-1zm3 0a.5.5 0 010 1h-1a.5.5 0 010-1h1zm-1 5a.5.5 0 010 1h-2a.5.5 0 010-1h2zm7 0a.5.5 0 110 1 .5.5 0 010-1z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Storage);
var _default = ForwardRef;
exports["default"] = _default;